import { Team } from "@brg/api";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useTeamMetaData } from "../hooks/useTeamMetaData";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useProfile } from "@brg/auth";
import { useLocation } from "react-router-dom";

interface IAddField {
  wasTruncated: boolean;
}
interface TeamContextValue {
  loading?: boolean;
  team: Team | null;
  additionalFields?: IAddField;
  teamInfo: any;
  teamInfoSync: any;
  isFeed?: boolean;
  isChannelParticipant?: boolean;
  onUpdateTeamState?: (v: boolean, field: string) => void;
}


const initial = {
  team: null,
  teamInfo: {},
  teamInfoSync: {},
  additionalFields: {
    wasTruncated: false
  },
  isFeed: false,
  isChannelParticipant: false,
  updateTeamField: undefined
}

export const TeamContext = createContext<TeamContextValue>(initial);

export const useTeamContext = () => {
  return useContext(TeamContext);
};

export const TeamProvider = ({ 
  children, 
  team, 
}: { 
  children: React.ReactNode, 
  team: Team | null, 
}) => {
  const profile = useProfile();
  const [isFeed, setIsFeed] = useState()
  const [additionalFields, setAdditionalFields] = useState({
    wasTruncated: false,
  });
  const location = useLocation() ;

  const { data: teamData, dataSync: teamDataSync, loading: teamDataLoading } = useTeamMetaData(team);

  const isChannelParticipant = useMemo(() => {
      if ([ModerationType.ChannelGroupOrCourse, ModerationType.Outer]?.includes(team?.moderationType ?? 0)) {
        return (team?.ownersIDs?.includes(profile?.accountId ?? '') || 
          team?.channelCommentWhiteListIds?.includes(profile?.accountId ?? '') || 
          team?.membersIDs?.includes(profile?.accountId ?? ''))
      }
      return true;
  }, [profile, team])

  const onUpdateTeamState = (data: boolean, field: string) => {
    if (field === 'feed') {
      setIsFeed(data);
    } 
    setAdditionalFields({
      ...additionalFields,
      [field]: data,
    })
  };

  const teamInfo = useMemo(() => {
    if (!team) {
      return null;
    }
    if (teamData) {
      return teamData;
    } else {
      return null;
    }
  }, [team, teamData])

  useEffect(() => {
   
  }, [team, teamData]);

  useEffect(() => {
    setIsFeed(location?.state?.isFeed ?? team?.isShowFeed ?? false);
  }, [team?.isShowFeed]);

  const value: TeamContextValue = {
    loading: teamDataLoading,
    team,
    teamInfo,
    teamInfoSync: teamDataSync,
    isFeed,
    additionalFields,
    isChannelParticipant,
    onUpdateTeamState
  };

  return (
    <TeamContext.Provider value={value}>
      {children}
    </TeamContext.Provider>
  );
};import { Team } from "@brg/api";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useTeamMetaData } from "../hooks/useTeamMetaData";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useProfile } from "@brg/auth";
import { useLocation } from "react-router-dom";

interface IAddField {
  wasTruncated: boolean;
}
interface TeamContextValue {
  loading?: boolean;
  team: Team | null;
  additionalFields?: IAddField;
  teamInfo: any;
  teamInfoSync: any;
  isFeed?: boolean;
  isChannelParticipant?: boolean;
  onUpdateTeamState?: (v: boolean, field: string) => void;
}


const initial = {
  team: null,
  teamInfo: {},
  teamInfoSync: {},
  additionalFields: {
    wasTruncated: false
  },
  isFeed: false,
  isChannelParticipant: false,
  updateTeamField: undefined
}

export const TeamContext = createContext<TeamContextValue>(initial);

export const useTeamContext = () => {
  return useContext(TeamContext);
};

export const TeamProvider = ({ 
  children, 
  team, 
}: { 
  children: React.ReactNode, 
  team: Team | null, 
}) => {
  const profile = useProfile();
  const [isFeed, setIsFeed] = useState()
  const [additionalFields, setAdditionalFields] = useState({
    wasTruncated: false,
  });
  const location = useLocation() ;

  const { data: teamData, dataSync: teamDataSync, loading: teamDataLoading } = useTeamMetaData(team);

  const isChannelParticipant = useMemo(() => {
      if ([ModerationType.ChannelGroupOrCourse, ModerationType.Outer]?.includes(team?.moderationType ?? 0)) {
        return (team?.ownersIDs?.includes(profile?.accountId ?? '') || 
          team?.channelCommentWhiteListIds?.includes(profile?.accountId ?? '') || 
          team?.membersIDs?.includes(profile?.accountId ?? ''))
      }
      return true;
  }, [profile, team])

  const onUpdateTeamState = (data: boolean, field: string) => {
    if (field === 'feed') {
      setIsFeed(data);
    } 
    setAdditionalFields({
      ...additionalFields,
      [field]: data,
    })
  };

  const teamInfo = useMemo(() => {
    if (!team) {
      return null;
    }
    if (teamData) {
      return teamData;
    } else {
      return null;
    }
  }, [team, teamData])

  useEffect(() => {
   
  }, [team, teamData]);

  useEffect(() => {
    setIsFeed(location?.state?.isFeed ?? team?.isShowFeed ?? false);
  }, [team?.isShowFeed]);

  const value: TeamContextValue = {
    loading: teamDataLoading,
    team,
    teamInfo,
    teamInfoSync: teamDataSync,
    isFeed,
    additionalFields,
    isChannelParticipant,
    onUpdateTeamState
  };

  return (
    <TeamContext.Provider value={value}>
      {children}
    </TeamContext.Provider>
  );
};